export function persistFlagOverrideFromUrl(param: string, key: string): void {
    if (typeof window === "undefined") return;
    try {
        const value = new URLSearchParams(window.location.search).get(param);
        if (value === "1" || value === "0")
            window.localStorage.setItem(key, value);
    } catch {}
}
